import React, {useState} from "react";
import {BaseModal} from "./modalStyle";
import ExitButton from "../buttons/ExitButton";
import styled from "styled-components";
import {BlueButton} from "../buttons/ButtonStyles";
import {useDispatch} from "react-redux";
import {
    loadAllTagCategories,
    patchTagCategory,
    postTagCategory
} from "../tag/tagCategory/tagCategoryAction";
import {patchTag, postSubTag} from "../tag/subTag/tagsAction";
import {FunctionalModal} from "./FunctionalModal";
import SendFormButton from "../buttons/SendFormButton";
import useSortItems from "../../custom-hooks/useSortItems";
import ChooseColor from "../inputs/ChooseColor";
import {Formik, ErrorMessage} from 'formik';
import * as Yup from "yup";
import {FormFormik, InputTextFormik} from "../inputs/InputStyle";

const AddTagModal = ({
                         isTag = false,
                         category = {},
                         setModalIsOpen,
                         isEditAction = false,
                     }) => {

    const dispatch = useDispatch()

    const isPatchCategoryAction = !isTag && isEditAction
    const isPostCategoryAction = !isTag && !isEditAction
    const isPostTagAction = isTag && !isEditAction
    const isPatchTagAction = isTag && isEditAction
    const categoryLength = Object.keys(category).length;
    const {returnRemovedItems, returnAddedItems, pushItemsByNameInArray} = useSortItems()

    const [tag, setTag] = useState('')
    const [tagsCreated, setTagsCreated] = useState(isPatchCategoryAction || categoryLength > 0 ? category?.tags : [])
    const [key, setKey] = useState(0)



    const handleChange = (e) => {
        const {value} = e.target;
        setTag(value)
    }

    const removeTag = (tag_id) => {
        tagsCreated.forEach((t) => {
            if (tag_id === t.id) {
                let remainTag = tagsCreated.filter(tag => tag.id !== t.id)
                setTagsCreated(remainTag)
            }
        })
    }

    const displayTag = () => {
        if (isPostCategoryAction || isPatchCategoryAction) {
            if (tagsCreated.length === 0) {
                return <p className={"fw-700"}> Pas de tags encore créés </p>
            } else {
                return (
                    <div className="flex-row gap-1 wrap">
                        {tagsCreated.map((t, index) => (
                            <TagCard key={index}>
                                <svg onClick={() => removeTag(t.id)} width="20" height="20" viewBox="0 0 24 24"
                                     fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="12" fill="#E9405B"/>
                                    <path
                                        d="M7.71429 17.3333C7.71429 18.25 8.35714 19 9.14286 19H14.8571C15.6429 19 16.2857 18.25 16.2857 17.3333V9C16.2857 8.08333 15.6429 7.33333 14.8571 7.33333H9.14286C8.35714 7.33333 7.71429 8.08333 7.71429 9V17.3333ZM9.85714 9H14.1429C14.5357 9 14.8571 9.375 14.8571 9.83333V16.5C14.8571 16.9583 14.5357 17.3333 14.1429 17.3333H9.85714C9.46429 17.3333 9.14286 16.9583 9.14286 16.5V9.83333C9.14286 9.375 9.46429 9 9.85714 9ZM14.5 4.83333L13.9929 4.24167C13.8643 4.09167 13.6786 4 13.4929 4H10.5071C10.3214 4 10.1357 4.09167 10.0071 4.24167L9.5 4.83333H7.71429C7.32143 4.83333 7 5.20833 7 5.66667C7 6.125 7.32143 6.5 7.71429 6.5H16.2857C16.6786 6.5 17 6.125 17 5.66667C17 5.20833 16.6786 4.83333 16.2857 4.83333H14.5Z"
                                        fill="#FAFAFA"/>
                                </svg>
                                <p> {t.name} </p>
                            </TagCard>
                        ))
                        }
                    </div>
                )
            }
        }
    }

    const addTags = async (e) => {
        let data = {}
        if (e.keyCode === 13 || e.target.className.includes('add-btn')) {
            setTagsCreated(prevState => [...prevState, {
                id: key,
                name: tag
            }
            ]);
            data.tags = [{"tagName": tag}]
            setTag("")
            setKey(key + 1)
            if (isPostTagAction) {
                await dispatch(postSubTag(category.id, data))
                await dispatch(loadAllTagCategories())
                setModalIsOpen(false)
            }
        }
    }


    const handleSubmitCategory = async (data) => {
        let newData = {}
        let keyNameForAdd = "tagName"
        let keyNameForDelete = "tagId"
        newData.name = data.name
        if (category.color !== data.color && data.color) {
            newData.color = data.color
        }

        if (isPatchCategoryAction) {
            let removedTags = returnRemovedItems(tagsCreated, category.tags, keyNameForDelete)
            let addedTags = returnAddedItems(tagsCreated, category.tags, keyNameForAdd)
            if (removedTags) {
                newData.removeTags = removedTags
            }
            if (addedTags) {
                newData.tags = addedTags
            }
        }
        if (isPostCategoryAction) {
            // add tag when create a category
            let addedTags = pushItemsByNameInArray(tagsCreated, keyNameForAdd)
            if (addedTags) {
                newData.tags = addedTags
            }
        }
        if (isPostCategoryAction) {
            await dispatch(postTagCategory(newData))
        } else {
            await dispatch(patchTagCategory(category.id, newData))
        }
        await dispatch(loadAllTagCategories())
        setModalIsOpen(false)


    }

    const handleSubmitTag = async (data) => {
        let newData = {}
        newData.name = data.name

        if (isEditAction) {
            await dispatch(patchTag(category.id, newData))
        } else {
            let dataNewTag = {id: 0, ...newData}
            let keyNameForAdd = "tagName"
            let allTags = []
            category.tags.forEach((t) => {
                allTags.push(t)
            })
            allTags.push(dataNewTag)
            let newTag = returnAddedItems(allTags, category.tags, keyNameForAdd)
            let newDataTag = {}
            newDataTag.tags = newTag
            await dispatch(patchTagCategory(category.id, newDataTag))
        }
        await dispatch(loadAllTagCategories())
        setTimeout(() => setModalIsOpen(false), 500)
    }
    const displayTitle = () => {
        let categoryTitle = "catégorie"
        let tagTitle = "tag"
        if (isPatchCategoryAction) {
            return "Modifier la " + categoryTitle
        }

        if (!isTag) {
            return "Ajouter une " + categoryTitle
        } else {
            if (isEditAction) {
                return "Modifier un " + tagTitle
            }
            return 'Ajouter un  ' + tagTitle
        }
    }

    const validateSchema = Yup.object({
        name: Yup
            .string()
            .min(2, "Ce nom est trop court")
            .required(`Veuillez écrire un nom de ${isTag ? "tag" : "catégorie"}`),
        color: Yup
            .string()
    })

    const displayModal = () => {
        return (
            <Modal className={"gap-1"}>
                <FirstSection>
                    <h1> {displayTitle()} </h1>
                    <ExitButton
                        closeUpdate={() => setModalIsOpen(false)}
                    />
                </FirstSection>
                <Formik
                    enableReinitialize
                    initialValues={{
                        name: isEditAction ? category.name : "",
                        color: isEditAction ? category.color : "",
                    }}
                    validationSchema={validateSchema}
                    onSubmit={!isTag ? handleSubmitCategory : handleSubmitTag}
                >
                    {({isValid, isSubmitting}) => (
                        <Form>
                            {isTag &&
                            <TagCard secondary
                                     style={{backgroundColor: category.color}}>
                                <h3>{category.name}</h3>
                            </TagCard>
                            }
                            <div className={"flex-col gap-05"}>
                                <label> Nom {isTag ? "sdu tag" : "de la catégorie"} :</label>
                                <InputTextFormik
                                    name='name'
                                    placeholder={`Écrivez le nom ${isTag ? "du tag" : "de la catégorie"}`}
                                />
                                <ErrorMessage
                                    name="name"
                                    render={msg => <div><p className="error-text"> {msg} </p></div>}
                                />
                            </div>


                            {!isTag &&
                            <>
                                <ChooseColor
                                    color={category.color}
                                    handleChange={handleChange}
                                />
                                <ErrorMessage
                                    name="color"
                                    render={msg => <div><p className="error-text"> {msg} </p></div>}
                                />
                            </>

                            }
                            {!isTag &&
                            <InputContainer className={`${isTag ? "ai-center" : ""}`}>
                                <div className="flex-row gap-1 w-100">
                                    {!isTag &&
                                    <label>
                                        Créer des tags :
                                    </label>
                                    }
                                    {(isPostTagAction || isPostCategoryAction || isPatchCategoryAction || !isPatchTagAction) &&
                                    <AddTagContainer className={`flex-row gap-1 ${isTag ? "jtc-center w-100" : ""}`}>
                                        <InputTextFormik
                                            name='tag'
                                            type="text"
                                            placeholder='Écrivez le nom du tag'
                                            onChange={handleChange}
                                            value={tag}
                                        />
                                        <AddTagButton
                                            type={"button"}
                                            className={"add-btn"}
                                            onClick={addTags}
                                        >
                                            <h6 className={"add-btn"}>
                                                Ajouter
                                            </h6>
                                        </AddTagButton>
                                    </AddTagContainer>
                                    }

                                </div>
                                {displayTag()}
                            </InputContainer>
                            }
                            <p>{isValid}</p>
                            <SendFormButton
                                state={isValid && !isSubmitting}
                                actionName={isEditAction ? "Modifier" : "Créer"}
                            />
                        </Form>
                    )}

                </Formik>

                {/*</Form>*/}

            </Modal>
        )

    }

    return (
        <>
            <FunctionalModal
                setOpen={setModalIsOpen}
                component={displayModal()}
            />
        </>
    )
}


const Modal = styled(BaseModal)`
  height: fit-content;
  gap: 1rem;


  #send-category-tag-bnt {
    align-self: center;
  }

  @media (min-width: 600px) {
    width: 600px;
  }
`
const Form = styled(FormFormik)`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`
const FirstSection = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 1em;

  h1 {
    flex-grow: 1;
    text-align: center;
  }
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  border-radius: 10px;
  justify-content: center;
  align-items: center;

  div:first-child {
    display: flex;
    align-items: center;
  }
`

const AddTagContainer = styled.div`
  display: flex;
  flex-grow: 0.7;
`

const TagCard = styled.div`
  display: flex;
  gap: 0.5em;
  padding: 0.5em 1em;
  border-radius: 10px;
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  border-color: ${props => props.secondary ? "transparent" : "rgba(33, 37, 41, 1)"};
  font-weight: ${props => props.secondary ? "700" : "initial"};
  align-self: center;

  &:hover {
    background-color: rgba(166, 172, 181, 0.3);
    border-color: transparent;
  }
`
const AddTagButton = styled(BlueButton)`
  padding: 0.1em 1em;
`


export default AddTagModal
